import React, {useCallback, useMemo} from "react";
import Select, {components, ValueContainerProps} from "react-select";
import { CommonInputProps } from ".";
import { DayProps } from "../../Day";
import { examinationCustomStyles, InputContainer } from "./InputStyles";
import { useDispatch, useSelector } from "../../../../../store/store";
import {
    getSpecializations,
    getSpecializationValues,
    isDayDisabled,
    setSpecializations,
} from "../../../../../store/data";
import { useTranslation } from "react-i18next";
import {faCheck} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

interface Props extends CommonInputProps {
    specIds: number[];
    day: DayProps;
    consultationIndex: number;
}

const CustomValueContainer = ({ t, children, ...props }: ValueContainerProps & { t: Function }) => {
  const selectedOptions = React.Children.toArray(children).filter(
    (child) => child && React.isValidElement(child) && child.type === components.MultiValue
  );
  const length = selectedOptions.length;
  let tmpChildren = React.Children.toArray(children);

  if (length > 0) {
    tmpChildren = [
      t('selected_examinations', { count: length }),
      ...tmpChildren.filter((child) => child && React.isValidElement(child) && child.type !== components.MultiValue)
    ];
  }

  return (
    <components.ValueContainer {...props}>{tmpChildren}</components.ValueContainer>
  );
};

const CustomOption = (props: any) => {
  console.log(props)
  return(
    <components.Option {...props}>
      {props.data.label}
      {props.isSelected && (<FontAwesomeIcon icon={faCheck} />)}
    </components.Option>
  )
}

const ExaminationSelect = ({ specIds, day, consultationIndex }: Props) => {
    const dispatch = useDispatch();
    const dayDisabled = useSelector(isDayDisabled(day));
    const specializations = useSelector(getSpecializations);
    const specializationValues = useSelector(getSpecializationValues(specIds));
    const { t } = useTranslation();

    const handleChange = (value: unknown) => {
        const newValue = value as { value: string; label: string }[];
        dispatch(
            setSpecializations({
                day,
                consultationIndex,
                specializationIds: newValue.map((val) => parseInt(val.value)),
            })
        );
    };

    const options = useMemo(
          () =>
              specializations.map((spec) => ({
                  label: spec.specialization,
                  value: spec.specialization_id,
              })),
          [specializations]
      );

  const CustomValueContainerWithTranslation = useCallback(
    (props: ValueContainerProps) => <CustomValueContainer t={t} {...props} />,
    [t]
  );

    return (
        <InputContainer>
            <Select
                defaultValue={specIds}
                isDisabled={dayDisabled}
                onChange={handleChange}
                menuPlacement={day.index < 3 ? "bottom" : "top"}
                isMulti
                name="colors"
                closeMenuOnSelect={false}
                options={options}
                className="basic-multi-select"
                classNamePrefix="select"
                hideSelectedOptions={false}
                isClearable={false}
                openMenuOnClick
                placeholder={t("all_examinations")}
                value={specializationValues}
                styles={examinationCustomStyles}
                components={{ ValueContainer: CustomValueContainerWithTranslation, Option: CustomOption }}
            />
        </InputContainer>
    );
};

export default ExaminationSelect;
